// Empty module for unsupported Node.js modules in browser
module.exports = {};
